jQuery(document).ready(function(){
  jQuery(".panelbody-more").click(function(){ 
    jQuery(".description-content-inner").toggleClass('features-full', '');  
    jQuery(".panelbody").toggleClass('gradientbg', 'nobg');
    if ($(".panelbody-more p").text() == "Read more")
       $(".panelbody-more p").text("Read less")
    else
       $(".panelbody-more p").text("Read more");
  });
  jQuery(".features-more").click(function(){ 
    jQuery(".product-desc-tab").toggleClass('features-full', '');    
    jQuery(".features-panelbody").toggleClass('features-gradientbg', 'nobg');
    if ($(".features-more p").text() == "Read more")
       $(".features-more p").text("Read less")
    else
       $(".features-more p").text("Read more");
    
  }); 
  jQuery(".features-more-mbl").click(function(){ 
    jQuery(".accordion-content").toggleClass('features-full', '');
    jQuery(".features-panelbody").toggleClass('features-gradientbg', 'nobg');
    if ($(".features-more-mbl p").text() == "Read more")
       $(".features-more-mbl p").text("Read less")
    else
       $(".features-more-mbl p").text("Read more");
  });
  jQuery(".short-desc-more").hide();
  jQuery(".custom-field--value .features-panelbody").hide();
  if(jQuery(".custom-field--value").height() > 130){
  	jQuery(".short-desc-more").show();
    jQuery(".custom-field--value").addClass('features-short'); 
    jQuery(".custom-field--value .features-panelbody").show();
  }
  
  jQuery(".short-desc-more").click(function(){ 
    jQuery(".custom-field--value").toggleClass('features-full', ''); 
    jQuery(".features-panelbody").toggleClass('features-gradientbg', 'nobg');
    jQuery(".features-panelbody").html(jQuery(".features-panelbody").html() == '&nbsp;' ? '' : '&nbsp;');
    if ($(".short-desc-more").text() == "Read more")
       $(".short-desc-more").text("Read less")
    else
       $(".short-desc-more").text("Read more");
    
  });
  jQuery( ".boost-pfs-filter-option-number-of-doors .boost-pfs-filter-option-label" ).each(function() {
    var label = jQuery(this).find(".boost-pfs-filter-option-value").text();
    var label_array = label.split(' ');
    var lastEl = label_array[label_array.length-1];
    console.log(lastEl);
    if(lastEl != 'Wardrobes'){
      jQuery(this).find(".boost-pfs-filter-option-value").text(label +' Wardrobes');
    }
  });

   
  if ($(window).width() < 750){
    $('.tab-content').hide();
    $('.description-content').show();
    $('.tab h2').on('click', function(e){    
        e.preventDefault();
        $(this).toggleClass('open');
        $(this).parents('.tab').find('.tab-content').slideToggle();
        if(window.location.hash != $(this).attr('data-href')){
          window.location.hash = $(this).attr('data-href');
        }
    });

    $('.accordion-content').hide();
    $('h2.accordion-heading').on('click', function(e){    
        e.preventDefault();
        $(this).toggleClass('open');
        $(this).parents('.accordion-item').find('.accordion-content').slideToggle();
        if(window.location.hash != $(this).attr('data-href')){
          window.location.hash = $(this).attr('data-href');
        }
    });
    $(".scrolls").click(function(e) {
      e.preventDefault();
      var data_div = $(this).attr('data-div'); 
      if(!$('.tab-container .tab[data-id="'+ data_div +'"] h2').hasClass('open')){
        $('.tab-container .tab[data-id="'+ data_div +'"] h2').toggleClass('open');
      }
      if(!$('.tab-container .tab[data-id="'+ data_div +'"] .tab-content').hasClass('open')){
        $('.tab-container .tab[data-id="'+ data_div +'"] .tab-content').show();
      }
      if(window.location.hash != $(this).attr('href')){
        window.location.hash = $(this).attr('href');
      }
      $('html, body').animate({
          scrollTop: $('.tab-container .tab[data-id="'+ data_div +'"]').offset().top
      }, 1000);    
    });
  }
  else{
     $(".scrolls").click(function(e) {
      e.preventDefault();
      var data_div = $(this).attr('data-div');
      
      $('.tab-container .tab').removeClass('tab-active');
      $('.tab-container .tab[data-id="'+ data_div +'"]').addClass('tab-active');
      console.log($('.tab-container .tab[data-id="'+ data_div +'"]').html());
      $('.tab-menu ul li a').removeClass('active').parent().removeClass('active');
      $('.tab-menu ul li a[data-id="'+ data_div +'"]').addClass('active').parent().addClass('active');
      if(window.location.hash != $(this).attr('href')){
        window.location.hash = $(this).attr('href');
      }
      $('html, body').animate({
          scrollTop: $(".product-specifications").offset().top
      }, 1000);    
  });
  }
  
  var scroll_to_sec = window.location.hash;
  //console.log(scroll_to_sec);
  if(scroll_to_sec != ""){
    var sec = scroll_to_sec.replace('#', '');
    console.log(sec);
    var data_div = $('.product-specifications .tab-menu ul li a[data-href="'+ sec +'"]').attr('data-id');  
    console.log(data_div);
    //$('.tab-content').show();
    
    if ($(window).width() < 750){      
      if(!$('.tab-container .tab[data-id="'+ data_div +'"] h2').hasClass('open')){
        $('.tab-container .tab[data-id="'+ data_div +'"] h2').toggleClass('open');
      }
      
      $('.tab-container .tab[data-id="'+ data_div +'"] .tab-content').show();
      if(!$('.tab-container .tab[data-id="'+ data_div +'"] .tab-content').hasClass('open')){
        $('.tab-container .tab[data-id="'+ data_div +'"] .tab-content').show();
      }   
      $('html, body').animate({
          scrollTop: $('.tab-container .tab[data-id="'+ data_div +'"]').offset().top
      }, 1000);   
    }
    else{
    
     $('.tab-container .tab').removeClass('tab-active');
     $('.tab-container .tab[data-id="'+ data_div +'"]').addClass('tab-active');
     
     $('.tab-menu ul li a').removeClass('active').parent().removeClass('active');
     $('.tab-menu ul li a[data-id="'+ data_div +'"]').addClass('active').parent().addClass('active');
          
      $('html, body').animate({
          scrollTop: $(".product-specifications").offset().top
      }, 1000); 
    }
  }

  // scroll
  $(".collection-list .collection-list__item a").click(function(e) {
      //e.preventDefault();      
      var href = $(this).attr('href');
      var arr=href.split('#')[1];

      $('html, body').animate({
          scrollTop: $("#"+arr).offset().top
      }, 500);
  });

  //add assembly price in tabs
  var assembly_ids = ['4893784539213','6711761895501','6711764713549','6711764779085','6711764779085','6711764811853','6711764844621','6716495298637'];
  //console.log(assembly_ids.length);
  for (let i = 0; i < assembly_ids.length; i++) {
      // do something with `substr[i]`
      var assembly_price = jQuery('.input-block[data-id="'+ assembly_ids[i] +'"][data-index="2"]').find('.title .product-extras-price').attr('data-price');
      if(typeof assembly_price !== 'undefined'){  
          jQuery('.tab[data-id="tab3"] .tab-content .assembly-price').text(' £'+assembly_price);
      }
  }

  // New filter development
  
  jQuery('.custom-links button.boost-pfs-filter-button').on('click', function(){
      jQuery(this).parent().toggleClass('active');
      jQuery(this).parent().find('.boost-pfs-filter-option-content').toggle();
      jQuery(this).parents().find('.boost-pfs-filter-right-col').toggleClass("notransform");
  });
  jQuery('.boost-pfs-filter-left-col *').on('click', function(){      
      setTimeout(function () {
        var url = window.location.href;
        if(url.includes('?')){
          console.log('has');
          jQuery('.custom-links.hide-mobile').hide();
          jQuery('.all-wardrobes .boost-pfs-filter-right-col').css('transform','none').css('margin-bottom','-50px');
                   
        }else{
          console.log('not has');
          jQuery('.custom-links.hide-mobile').show();
          jQuery('.all-wardrobes .boost-pfs-filter-right-col').css('transform','translateY(-143px)').css('margin-bottom','-193px');
          jQuery('.custom-links button.boost-pfs-filter-button').parent().toggleClass('active');
          jQuery('.custom-links button.boost-pfs-filter-button').parent().find('.boost-pfs-filter-option-content').toggle();
          jQuery('.custom-links button.boost-pfs-filter-button').parents().find('.boost-pfs-filter-right-col').toggleClass("notransform"); 
        }
        jQuery('.all-wardrobes .boost-pfs-filter-tree-v .boost-pfs-filter-option-type').show();
        jQuery('.all-wardrobes .boost-pfs-filter-tree-v .boost-pfs-filter-option-type').addClass('show');
      }, 1000);
  });
  var url = window.location.href;
  if(url.includes('?')){
    jQuery('.custom-links').hide();
    jQuery('.all-wardrobes .boost-pfs-filter-right-col').css('transform','none').css('margin-bottom','-50px');
  }
});

 
$( document ).ready(function() {
 /* $('.tobii__close').click(function() {
    location.reload();
  });*/

jQuery(".product__description table").parent().addClass("table-container");
  
jQuery('.product__description span:contains(.)').each(function(){
	//alert(jQuery.trim(jQuery(this).text()).length);
	if(jQuery.trim(jQuery(this).text()).length <= 1) { 
      jQuery(this).hide(); 
    }
});
  
var stopAllYouTubeVideos = () => { 
  var iframes = document.querySelectorAll('iframe');
  Array.prototype.forEach.call(iframes, iframe => { 
    iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', 
  func: 'stopVideo' }), '*');
 });
}

jQuery('.product__media-item .deferred-media__poster-button').on('click',function(){
  stopAllYouTubeVideos();
});
  
$('.thumbnail-slider .slider__slide').click(function(e) {
  e.preventDefault();  
  
  //var index = parseInt($(this).parent().index()) + 1;
  //console.log(index);
  
 // var src = $(this).find('.product__media img').attr('src');
  //var srcset = $(this).find('.product__media img').attr('srcset');
 // $('.product__media-featured .product__media-item .product__media img').attr('srcset',srcset).attr('src',src);
  //$('.product__media-featured .product__media-item .product-media-thumbnail').attr('href',src);
  //$('.product__media-featured .product__media-item').hide();
  
  var mediaId = $(this).attr("data-media-id");
  //console.log(mediaId);
  $('.product__media-featured [data-media-id='+ mediaId +']').prependTo(".slider--mobile");
  //$('.product__media-featured .product__media-item:nth-child('+ index +')').prependTo(".slider--mobile");
  
});

  
  // Count of search results
  var url= window.location.pathname;
  var search_page_url = url.split("/");
  var search_page = search_page_url[search_page_url.length-1];
  //console.log(search_page);
  
  if(search_page == 'search'){
  	var all_li = $('.template-search__results ul li').length;
    console.log(all_li);
    $('.element-margin .search-count').text(all_li);
    $('title').text('Search: '+$('.element-margin').text());
  }
  
  $('.c-handle-option').click(function() {
    $('.handle-options .input-block').removeClass('active');
    $(this).parent('.input-block').addClass('active');
  });
  $('.c-trim-option').click(function() {    
    $('.trim-options .input-block').removeClass('active');
    $(this).parent('.input-block').addClass('active');
  });
    
  
  //Product extras price calculation
  
  $('.product__info-container .price__sale span.price-item--sale').append('<span class="extra-price"></span><span class="total-price"></span>');
  $('.product__info-container .price__regular .price-item').append('<span class="extra-price"></span><span class="total-price"></span>');
  if(jQuery('.product__info-container .price .price__regular .price-item').length > 0){
    var product_price = jQuery('.product__info-container .price .price__regular .price-item').text().trim().split("£")['1'].replace(/,/g , '');
    //product_price = parseInt(product_price.replace(/,/g , ''));

    $('.product-form__input select.select__select').on('change', function() {
      setTimeout(function(){	
          product_price = jQuery('.product__info-container .price .price__regular .price-item').text().trim().split("£")['1'].replace(/,/g , '');
      }, 1000);
    });

    //console.log(product_price);
//     $('input[type="radio"].product-extras').click(function() { 
// 		$(this).parent().removeClass('active');
//     	$(this).parent('.input-block').addClass('active');
// 	});
    $('.product-extras').click(function() {     
      //$('.product-extra-options').css('margin-bottom','60px');
      //var qty = parseInt(1);  
      var varient_id = $('.product-form .form input[name="id"]').val();
      var type = $(this).attr('type');
      
      if(type == 'checkbox'){
        if ($(this).parent().hasClass("active")) {

          var price = $(this).parent().find('.qty').attr('data-price');
          //console.log(price);

          if(($(this).parent().find('.qty').val()) != null){
            var qty = parseInt($(this).parent().find('.qty').val());
          }else{
            var qty = parseInt('1');
          }
          //console.log(qty);
		  
          $(this).parent().find('.lineproperty').attr('name', '').val('');
          
          var total_price = parseInt(price*qty);

          $(this).parent().find('.qty').attr('totalprice', total_price);

          var extras_price_text = $('.extra-price').text();
          
          if(extras_price_text.length > 0){
            var extras_price = extras_price_text.split("£");
            var reduced_price = parseInt(extras_price['1']) - parseInt(total_price);

            $('.extra-price').text(' + £'+reduced_price); 
            $('#product_extras_price').val(reduced_price); 

            var total_productprice = parseInt(product_price) + parseInt(reduced_price);
            $('.total-price').text(' = £'+total_productprice);

            if(reduced_price == '0'){
              $('.extra-price').text('');
              $('.total-price').text('');
            }
          }
        } 
        else{  
          
          var varient_id = $('.product-form .form input[name="id"]').val();
            //console.log(varient_id);
            var price = parseInt($(this).parent().find('.qty').attr('data-price'));
          //console.log(price);

          if(($(this).parent().find('.qty').val()) != null){
            var qty = parseInt($(this).parent().find('.qty').val());
          }else{
            var qty = parseInt('1');
          }
          //console.log(qty);
			
          // line properties
          var option_id = $(this).parent().find('.qty').attr('data-varient');
          var variation_id = $(this).parent().attr('data-id')+'_'+$(this).parent().attr('data-index');
    	  $(this).parent().find('.lineproperty').attr('name','properties['+variation_id+']').val(option_id+'_'+qty);
          //$(this).parent().find('.lineproperty').attr('name', 'properties['+varient_id+'_'+qty+']');
          
          var total_price = parseInt(price*qty);
          $(this).parent().find('.qty').attr('totalprice', total_price);
          //console.log(total_price);
          var extras_price_text = $('.extra-price').text();
          //console.log(extras_price_text);
          if(extras_price_text.length > 0){
            var extras_price = extras_price_text.split("£");
            var sum_price = parseInt(extras_price['1']) + parseInt(total_price);
            //console.log(sum_price);
          }else {
            var sum_price = parseInt(total_price);
          }

          $('.extra-price').text(' + £'+sum_price); 
          $('#product_extras_price').val(sum_price);

          $(this).attr('data-price', price/100);

          var total_productprice = parseInt(product_price) + parseInt(sum_price);
          $('.total-price').text(' = £'+total_productprice);

          if(sum_price == '0'){
            $('.extra-price').text('');
            $('.total-price').text('');
          }		
        }
        $(this).parent('.input-block').toggleClass('active');
      	$(this).parent('.input-block:not(.true)').toggleClass('mb-5');
      }
      
      else if(type == 'radio'){
        
        if ($(this).parent().hasClass("active")) {
// 		  console.log('has class');
//           var price = $(this).parent().find('.qty').attr('data-price');
                    
//           //console.log(price);

//           if(($(this).parent().find('.qty').val()) != null){
//             var qty = parseInt($(this).parent().find('.qty').val());
//           }else{
//             var qty = parseInt('1');
//           }
//           //console.log(qty);

//           var total_price = parseInt(price*qty);

//           $(this).parent().find('.qty').attr('totalprice', total_price);

//           var extras_price_text = $('.extra-price').text();
          
//           var totalprice=0;
//           var totalexprice=0;
//           $('[data-exprice]').each(function () {	
//               totalprice = $(this).attr('data-exprice');
//               if(totalprice != null){
//               totalexprice += parseInt(totalprice);
//               }
//           });
          
//           console.log(totalexprice);
          
//           if(extras_price_text.length > 0){
//             var extras_price = extras_price_text.split("£");
//             //var reduced_price = parseInt(extras_price['1']) - parseInt(total_price);
//             var reduced_price = parseInt(totalexprice) - parseInt(total_price);
            

//             console.log(reduced_price);
            
//             $('.extra-price').text(' + £'+reduced_price); 
//             $('#product_extras_price').val(reduced_price); 

//             var total_productprice = parseInt(product_price) + parseInt(reduced_price);
//             $('.total-price').text(' = £'+total_productprice);			            
            
//             if(reduced_price == '0'){
//               $('.extra-price').text('');
//               $('.total-price').text('');
//             }
//           }
//           $(this).parent().parent().attr('data-exprice', '0');
          //$(this).parent().find('.lineproperty').attr('name', '').val('');
        } 
        else{
          console.log('not has class');
          var varient_id = $('.product-form .form input[name="id"]').val();
          //console.log(varient_id);
          var price = parseInt($(this).parent().find('.qty').attr('data-price'));                    
          
          
          //console.log(price);		  
          if(($(this).parent().find('.qty').val()) != null){
            var qty = parseInt($(this).parent().find('.qty').val());
          }else{
            var qty = parseInt('1');
          }
          //console.log(qty);
		  var option_id = $(this).parent().find('.qty').attr('data-varient');
          var variation_id = $(this).parent().attr('data-id')+'_'+$(this).parent().attr('data-index');
          //$(this).parent().find('.lineproperty').attr('name',variation_id).val('properties['+option_id+'_'+qty+']');
          $(this).parent().find('.lineproperty').attr('name','properties['+variation_id+']').val(option_id+'_'+qty);
          //$(this).parent().find('.lineproperty').attr('name', 'properties['+varient_id+'_'+qty+']');
          
          var total_price = parseInt(price*qty);
          $(this).parent().find('.qty').attr('totalprice', total_price);
          console.log(total_price);
          var extras_price_text = $('.extra-price').first().text();
          var exprice = $(this).parent().parent().attr('data-exprice');
          
          console.log(extras_price_text);
          console.log(exprice);
          
          if(extras_price_text.length > 0 && exprice != null){
            var extras_price = extras_price_text.split("£");
            var sum_price = parseInt(extras_price['1']) + parseInt(total_price) - parseInt(exprice);
            console.log(sum_price);
          }else if(extras_price_text.length <= 0 && exprice != null) {
            var sum_price = parseInt(total_price) - parseInt(exprice);
          }else{
          	var sum_price = parseInt(total_price);
          }
          console.log(sum_price);

          $('.extra-price').text(' + £'+sum_price); 
          $('#product_extras_price').val(sum_price);

          $(this).attr('data-price', price/100);

          var total_productprice = parseInt(product_price) + parseInt(sum_price);
          $('.total-price').text(' = £'+total_productprice);

          $(this).parent().parent().attr('data-exprice', price);
          if(sum_price == '0'){
            $('.extra-price').text('');
            $('.total-price').text('');
          }		
        }
        
        
		$(this).parent().siblings('.input-block').removeClass('active');
        $(this).parent().siblings('.input-block').find('.lineproperty').attr('name', '').val('');
      	$(this).parent('.input-block').addClass('active');	
      }
	  
      var qty = parseInt(jQuery('.quantity__input').val());
      var extras_p = parseInt(jQuery('#product_extras_price').val());
      var total_p = qty*(extras_p+parseInt(product_price));
      $('.with-qty').remove();
      if(qty>1){
        $('.total-price').append('<span class="with-qty">* '+ qty +' = £'+ total_p +'</span>'); 
      }
      
      var checkboxes = document.querySelectorAll('.product-extras');
      var qty = document.querySelectorAll('.qty');

  //     var hiddenfield = document.getElementById('all-product-extras');
  //     hiddenfield.value = ""
  //     var i;
  //     for (i = 0; i < checkboxes.length; i++) {
  //         var x = checkboxes[i];
  //         var y = qty[i];
  //         if(x.checked){
  //           if(hiddenfield.value==""){
  //               hiddenfield.value = x.value + ":" + y.value;
  //             }else{
  //               hiddenfield.value = hiddenfield.value + ", " + x.value + ":" + y.value; 
  //             } 
  //           }        
  //        }
        //console.log(hiddenfield.value);
    });


    $(".input-block .qty").on("keyup keydown change",function(event){
    var varient_id = $('.product-form .form input[name="id"]').val();
	
	//$('.extra-price').text('');
    var price = $(this).attr('data-price');
	if(($(this).val()) != null){
    	var qty = $(this).val();   
    }else {
    	var qty = parseInt('1');
    } 
      
    var option_id = $(this).parent().find('.qty').attr('data-varient');
    var variation_id = $(this).parent().attr('data-id')+'_'+$(this).parent().attr('data-index');
    //$(this).parent().find('.lineproperty').attr('name',variation_id).val('properties['+option_id+'_'+qty+']');
    $(this).parent().find('.lineproperty').attr('name','properties['+variation_id+']').val(option_id+'_'+qty);
	var total_price = parseInt(price*qty);
    $(this).attr('totalprice', total_price);
    //console.log(total_price);

	var output=0;
    var totalprice=0;
    $('.input-block.active .qty').each(function () {	
        var totalprice = $(this).attr('totalprice');
        if(totalprice != null){
        output += parseInt(totalprice);
        }
    });
    //console.log(output);	
    
    
    
	$('.extra-price').text(' + £'+output);
	$('#product_extras_price').val(output);
    
    var total_productprice = parseInt(product_price) + parseInt(output);
    $('.total-price').text(' = £'+total_productprice);
    
     if(output == '0'){
		 $('.extra-price').text('');
      	 $('.total-price').text('');
      }
    
    $(this).parent().find('.product-extras').attr('data-price', price/100);
      
    var qty = parseInt(jQuery('.quantity__input').val());
    var extras_p = parseInt(jQuery('#product_extras_price').val());
    var total_p = qty*(extras_p+parseInt(product_price));
    $('.with-qty').remove();
    if(qty>1){
      $('.total-price').append('<span class="with-qty">* '+ qty +' = £'+ total_p +'</span>'); 
    }
    
    var checkboxes = document.querySelectorAll('.product-extras');
	var qty = document.querySelectorAll('.qty');
    
//     var hiddenfield = document.getElementById('all-product-extras');
//     hiddenfield.value = ""
//     var i;
//     for (i = 0; i < checkboxes.length; i++) {
//         var x = checkboxes[i];
//         var y = qty[i];
//         if(x.checked){
//           if(hiddenfield.value==""){
//               hiddenfield.value = x.value + ":" + y.value;
//             }else{
//               hiddenfield.value = hiddenfield.value + ", " + x.value + ":" + y.value; 
//             } 
//           }        
//        }
      //console.log(hiddenfield.value);  
  });
    
    
    $(".quantity__button").on("click",function(e){
        var qty = parseInt(jQuery('.quantity__input').val());
        var extras_p = parseInt(jQuery('#product_extras_price').val());
      	var product_price = parseInt(jQuery('.product__info-container .price .price__regular .price-item').text().trim().split("£")['1'].replace(/,/g , ''));
//         console.log(qty); 
//         console.log(extras_p);
// 		console.log(product_price);
        var total_p = qty*(extras_p+parseInt(product_price));
        console.log(total_p);
      	$('.with-qty').remove();
        if(qty>1){
          $('.total-price').append('<span class="with-qty">* '+ qty +' = £'+ total_p +'</span>'); 
        }
      
    });
  }
  
  
  
//Product extras add to cart AJAX    
//jQuery(".product-form .form" ).submit(function( e ) {
jQuery(document).on('submit','.product-form .form',function(e){

    e.preventDefault();
    e.stopPropagation();

    // var active_extras = '0';
    // jQuery('.product-extra-options .input-block').each(function (){
    //  if(jQuery(this).hasClass('active') ){
    //    active_extras = '1';
    //  }
    // });
    //console.log(active_extras);
    //if(active_extras == '1'){
    // var current_item = {};
    // current_item['id'] = $('#product-form-installment input[name="id"]').val();
    // current_item['quantity'] = parseInt(jQuery(".product-form__input .quantity .quantity__input").val()) - 1;
    // items.push(current_item);


    //validation check   
    var validated = 0;

    jQuery('.product-extra-options > div[data-inputtype="radio"]').each(function(){
      
      var name = jQuery(this).find('.input-block input').attr('name');      
      var isValid = $('input[name="'+name+'"]').is(":checked");   
        
      //var isValid = $('input[name="'+name+'"]').parent().hasclass('active');
      //console.log(isValid); 

      if(isValid == true){
        jQuery(this).find("#spnError").hide();  
        jQuery(this).removeClass('validation-error');
      }else{
        jQuery(this).find("#spnError").show();
        jQuery(this).addClass('validation-error'); 
        validated = parseInt(validated) +1;
      }
    });
  

    if(validated == 0){

      var line_items = {};
      var items= [];
      var extras=[];
      var i=0;   
      
      var product_id = jQuery(this).find('input[name="id"]').val();
      var input_qty = parseInt(jQuery('.quantity__input').val());

      jQuery('.product-extras').each(function() { 

        var item= {};
        var extra={};
        //var line_item= {};
        if (jQuery(this).parent().hasClass("active")) {              
          if((jQuery(this).parent().find('.qty').attr('data-varient')) != null){
            item['id'] = parseInt(jQuery(this).parent().find('.qty').attr('data-varient')); 

            line_items['variant_id_'+i] = jQuery(this).parent().find('.qty').attr('data-varient') + '_' + jQuery(this).parent().find('.qty').val();
          }                         
          if((jQuery(this).parent().find('.qty').val()) != null){
            var qty = parseInt(jQuery(this).parent().find('.qty').val()) * parseInt(input_qty);

          }else{
            var qty = parseInt('1');
          }              

          i = i+qty;
          item['quantity'] = qty;   
          items.push(item);  
          //console.log(item);
          //console.log(items);              
          //line_items.push(line_item);

          if((jQuery(this).attr('value')) != null){
            extra['title'] = jQuery(this).attr('value');
          }                         
          if((jQuery(this).parent().find('.image').attr('src')) != null){
            extra['image'] = jQuery(this).parent().find('.image').attr('src');
          }

          var extraElement = '<div class="cart-notification-product"><img class="cart-notification-product__image" src="'+ extra['image'] +'" alt="'+ extra['title'] +'" width="70" height="51" loading="lazy"><div class="cart-notification-product__info"><h3 class="cart-notification-product__name h4">'+ extra['title'] +'</h3></div></div>';
          console.log(extraElement);
          $( extraElement ).insertAfter( "#cart-notification-product" );
          //var itemCount = i+1;                            		    
          //extras.push(extra);
          //console.log(extras);

        }

      });

      console.log(i);
      setTimeout(function(){
        if($('.cart-count-bubble span[aria-hidden="true"]').text() != ''){
          var currentCartitems = parseInt($('.cart-count-bubble span[aria-hidden="true"]').text());
        }else{
          var currentCartitems = parseInt('0');
        }
        $('.cart-count-bubble span[aria-hidden="true"]').text(i+currentCartitems);
        $('.cart-notification #cart-notification-button').text('View my cart ('+(i+currentCartitems)+')');
      }, 1500);

//       data = { items: items };	
//         setTimeout(function(){
//           jQuery.ajax({
//             type: 'POST',
//             url: '/cart/add.js',
//             headers: {
//               'Content-Type': 'application/json'
//             },
//             data: JSON.stringify(data),
//             dataType: 'json',
//             success: function(responce) {
//               console.log(responce);
//               console.log('Product added to cart');
              
//               linedata =  {"id":product_id, "quantity": input_qty, "properties":line_items } ;
//               jQuery.ajax({
//                 url: "/cart/add.js",
//                 type: "POST",
//                 data: JSON.stringify(linedata), 
//                 contentType: "application/json",
//                 dataType: 'json',
//                 success: function(responce) {
//                   console.log(responce);
//                   console.log('line items added to product');

//                 }            
//               });//add lineitems ajax 
//             }
//           });
//         }, 1000);

//       jQuery.ajax({
//         type: 'POST',
//         url: '/cart/add.js',
//         headers: {
//           'Content-Type': 'application/json'
//         },
//         data: JSON.stringify(data),
//         dataType: 'json',
//         success: function(responce) {
//           console.log(responce);
//           console.log('Product added to cart');

//           //linedata = [ { items: {"id":product_id, "quantity": input_qty, "properties":line_items } } ] ;
//           //jQuery.post('/cart/update.js', {updates: {product_id: 0}});

//           jQuery.getJSON('/cart.js', function(cart) {
//             console.log(cart.items);
//             var all_cartids = [];
//             var all_cartqty = [];
//             var line_items = [];
//             $.each(cart.items, function( index, value ) {        
//               all_cartids.push(value.id);
//               all_cartqty.push(value.quantity);
//               line_items.push(value.properties);
//             });

//             var product_id = jQuery('.product-form .form').find('input[name="id"]').val();
//             for(var i=0; i<all_cartids.length; i++){
//               var cart_id = all_cartids[i];
//               if(cart_id == product_id){
//                 //console.log('this product is in cart');   
//                 var hascart = true;
//                 var cart_product_qty = parseInt(all_cartqty[i]);
//                 break;
//               }else{ 
//                 //console.log('this product is not in cart'); 
//                 var hascart = false;
//               }
//             }
//             console.log(line_items);
//             console.log(hascart);
//             console.log(cart_product_qty);

            
//             var remove_item = {};
            
//             $.each(line_items, function( index, value ) {        
//               console.log(value);
//               console.log(line_items);
//             });

//             //check if product in cart then reduce qty else remove
//             if(hascart == true){
//               remove_item[product_id] = parseInt(cart_product_qty);
//             }else{
//               remove_item[product_id] = 0;
//             }


//             linedata =  {"id":product_id, "quantity": input_qty, "properties":line_items } ;
//             removedata = { updates: remove_item };
//             console.log(removedata);
//             jQuery.ajax({
//               url: "/cart/update.js",
//               type: "POST",
//               data: JSON.stringify(removedata), 
//               contentType: "application/json",
//               dataType: 'json',
//               success: function(responce) {
//                 console.log(responce);
//                 console.log('removed main product');
//                 //window.location.href = '/cart'; 
//                 console.log(linedata);

//                  jQuery.ajax({
//                   url: "/cart/add.js",
//                   type: "POST",
//                   data: JSON.stringify(linedata), 
//                   contentType: "application/json",
//                   dataType: 'json',
//                   success: function(responce) {
//                     console.log(responce);
//                     console.log('line items added to product');
                    
                    
//                     jQuery.ajax({
//                       url: "/cart/change.js",
//                       type: "POST",
//                       data: JSON.stringify(linedata), 
//                       contentType: "application/json",
//                       dataType: 'json',
//                       success: function(responce) {
//                         console.log(responce);
//                         console.log('line items added to product');

//                       }            
//                     });
                    
                    
//                   }            
//                 });//add lineitems ajax 
//               } // update success            
//             });// update ajax/remove main product or reduce quantity                  
//           });// getJSON cart
//         }// add all product success
//       });//add all product ajax     

      return true;

    }//validated 
    else{ return false;}
  
});
  
 
  
//     var checkboxes = [];
//     //var checkboxes = $('.product-extras');
//     $('.product-extras').each(function(){
//       var $this = $(this);
//       if ($this.is(':checked')) {
//         checkboxes.push($this.val());
//       }
//     });
        
  	//var hiddenfield = $('#all-product-extras');
  
  
// change image on click of thumbnail image
  $('.product-media-thumbnail').click(function(e) {
      e.preventDefault();    
      var src = $(this).find('.product__media img').attr('src');
	  var srcset = $(this).find('.product__media img').attr('srcset');
     // $('.product__media-featured .product__media-item .product__media img').attr('srcset',srcset).attr('src',src);
      //$('.product__media-featured .product__media-item .product-media-thumbnail').attr('href',src);
  });
  
// scroll effect
//   const slider = document.querySelector('.thumb-slider');
//   let isDown = false;
//   let startX;
//   let scrollLeft;

//   slider.addEventListener('mousedown', (e) => {
//     isDown = true;
//     slider.classList.add('active');
//     startX = e.pageX - slider.offsetLeft;
//     scrollLeft = slider.scrollLeft;
//   });
//   slider.addEventListener('mouseleave', () => {
//     isDown = false;
//     slider.classList.remove('active');
//   });
//   slider.addEventListener('mouseup', () => {
//     isDown = false;
//     slider.classList.remove('active');
//   });
//   slider.addEventListener('mousemove', (e) => {
//     if(!isDown) return;
//     //e.preventDefault();
//     const x = e.pageX - slider.offsetLeft;
//     const walk = (x - startX) * 3; //scroll-fast
//     slider.scrollLeft = scrollLeft - walk;
//     //console.log(walk);
//   });
  
  
  //adding zoom effect on product page
 // $('.zoom').zoom();
  
  //Product specification tab  
  $('.tab-link').click(function(e){  
    e.preventDefault();
    $(".tab").removeClass('tab-active');
    $(".tab-link").parent().removeClass('active');
    $(".tab[data-id='"+$(this).attr('data-id')+"']").addClass("tab-active");
    if(window.location.hash != $(this).attr('data-href')){
      window.location.hash = $(this).attr('data-href');
    }
    $(".tab-link").removeClass('active');
    $(this).parent().find(".tab-link").addClass('active');
    $(this).parent().find(".tab-link").parent().addClass('active');
  });
  
  //Product Specification Accordion
  
  //$('.accordion-item:not(:first) .accordion-content').hide();
  
//   $('.product-specifications .accordion > .accordion-item > .accordion-heading').on('click', function (e) {
//       e.preventDefault();      
//       const parentItem = $(this).parent();
//       const content = parentItem.find('.accordion-content').first();
//       $(this).toggleClass('open');
//       content.slideToggle();
//   });
  
  
  $('.collection-filter ul li a').click(function(e){
	e.preventDefault();
    var $filter_link = $(this).attr('href');
  	$('#main-collection-product-grid').css('opacity', '0.3');
    $( ".main-collection-products" ).load( $filter_link + ' #main-collection-product-grid', function() {
    	$('#main-collection-product-grid').css('opacity', '1');
		$('#main-collection-product-grid .collection-filter').prepend('<a href="#">Clear All</a>');
    });
    
    
  });
    
//cart page append price
//   var total_extra_price= 0;
//   $(".cart-items .cart-item").each(function() {
//    var extra_price = jQuery(this).find('.cart-item__details dl .product-option:last-child p').text(); 
//    var qty = $(this).find('.cart-item__quantity .quantity__input').val();
//    extra_price = extra_price*parseInt(qty);
    
//    //console.log(extra_price);
//     if($.isNumeric(extra_price)){
//       if(extra_price != null){
//         total_extra_price += parseInt(extra_price);
//       }
//     }
//     if((extra_price != null) && ($.isNumeric(extra_price))){
//       $(this).find('.cart-item__totals .cart-item__price-wrapper').append('<span class="extra-price">&nbsp;+ £'+ extra_price +'</span>');
//       $(this).find('.cart-item__details dl .product-option:last-child').hide();	
//     }
   
//   });
//   $('.cart__footer .totals .totals__subtotal-value').attr('data-total_extra_price',total_extra_price);
//   //var extra_price = jQuery('.totals__subtotal-value').attr('data-total_extra_price');
//   var total_price = jQuery('.totals__subtotal-value').text();
//   total_price = total_price.split('£')[1];
//   total_price = total_price.replace(/,/g , '');
//   var total = parseFloat(total_price)+parseFloat(total_extra_price);
//   jQuery('.totals__subtotal-value').text('£'+total+'.00');  

}); 

